import type { RouteAnalytics } from "@unbooking/analytics-gtm";
import { Routes } from "./routesFromContext";

// Shared with auctions-frontend-website so both apps report under the same service in GA4.
export const ANALYTICS_SERVICE_NAME = "UN System Online Auctions";
export const ANALYTICS_AGENCY_NAME = "WFP";
export const ANALYTICS_SERVICE_CATEGORY = "Online Auctions Digital Office";
export const ANALYTICS_DEFAULT_PAGE_TYPE = "Digital Office";
export const ANALYTICS_INFORMATIVE_PAGE_TYPE = "Informative Pages";

const SERVICE_SUBCATEGORIES: Record<Routes, string> = {
  [Routes.Home]: "Homepage",
  [Routes.WhyToDispose]: "Why To Dispose",
  [Routes.RequestDisposal]: "Request Disposal",
  [Routes.AuctionsList]: "Auctions List",
  [Routes.AuctionDetails]: "Auction Details",
  [Routes.AuctionAssetsAndLots]: "Auction Assets and Lots",
  [Routes.AuctionReport]: "Auction Report",
  [Routes.LotBidsList]: "Lot Bids List",
  [Routes.CreateAuction]: "Create Auction",
  [Routes.ManageRequests]: "Manage Requests",
  [Routes.AssetsManagement]: "Assets Management",
  [Routes.ManageUsers]: "Manage Users",
  [Routes.UserDetailsPage]: "User Details",
  [Routes.BidderDetailsPage]: "Bidder Details",
  [Routes.UserGuide]: "Digital Office guides",
};

/** `handle.analytics` for an app page. Its page type falls back to `ANALYTICS_DEFAULT_PAGE_TYPE`. */
export function pageAnalytics(route: Routes): RouteAnalytics {
  return { serviceSubcategory: SERVICE_SUBCATEGORIES[route] };
}

/** `handle.analytics` for the legal pages, which are reported as "Informative Pages". */
export const LEGAL_PAGE_ANALYTICS = {
  privacyPolicy: {
    pageType: ANALYTICS_INFORMATIVE_PAGE_TYPE,
    serviceSubcategory: "Privacy Policy",
  },
  termsAndConditions: {
    pageType: ANALYTICS_INFORMATIVE_PAGE_TYPE,
    serviceSubcategory: "Terms and Conditions",
  },
} satisfies Record<string, RouteAnalytics>;

export const APP_LINK_PAGE_ANALYTICS = {
  pageType: ANALYTICS_INFORMATIVE_PAGE_TYPE,
  serviceSubcategory: "App Link",
} satisfies RouteAnalytics;
